<sew-headline level="4" translate>SEARCH.INPUT.HEADLINE</sew-headline>
<div class="input-row">
    <div class="search-wrapper">
        @switch (isMobile) {
            @case (false) {
                <sew-search-field [error]="error ? true : false">
                    <ng-container *ngTemplateOutlet="searchContent"></ng-container>
                </sew-search-field>
            }
            @case (true) {
                <sew-input [status]="error ? 'error' : null">
                    <ng-container *ngTemplateOutlet="searchContent"></ng-container>
                </sew-input>
            }
        }

        <ng-template #searchContent>
            <input
                #searchfield
                [(ngModel)]="searchValue"
                (ngModelChange)="resetSearchError()"
                [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate"
                (keydown.enter)="onSearch()"
                (focus)="showHelpExpanded = true"
                autocomplete="off"
                class="search-input"
            />
            @if (!isMobile && !showHelpExpanded && error) {
                <div class="error-text">
                    {{ error.content | translate }}
                </div>
            }
            @if (!isMobile && showHelpExpanded) {
                <div #searchHelpWrapper class="search-help-wrapper">
                    <osc-search-help
                        [latestSearchTerms]="latestSearchTerms$ | async"
                        [criteriaExplanation]="criteriaExplanation$ | async"
                        [showSearchCriteria]="true"
                        (closeClicked)="showHelpExpanded = $event"
                        (latestSearchTermClicked)="searchValue = $event; onSearch()"
                        [isMobile]="isMobile"
                    ></osc-search-help>
                </div>
            }
        </ng-template>
    </div>
    <sew-button
        #searchButton
        class="button-submit-search"
        icon="search"
        [showIconOnly]="isMobile"
        (click)="onSearch()"
    >
        <button [disabled]="!searchValue">{{ 'SEARCH.ACTION.SEARCH' | translate }}</button>
    </sew-button>
    <osc-nameplate-search
        [icon]="showNameplateMobileIcon ? 'camera-document' : 'upload'"
        [apiKey]="ENVIRONMENT.apiGateway.dmz.apiKey"
        [apiUrl]="ENVIRONMENT.apiGateway.dmz.baseUrl + ENVIRONMENT.apiGateway.dmz.paths.drSerialnumberOcr"
        [tooltipText]="isMobile ? null : ('SEARCH.NAMEPLATE_SEARCH_TOOLTIP' | translate)"
        (searchResult)="onNameplateSearchResult($event)"
        oscTrackClick="search.ocrNameplate"
    >
    </osc-nameplate-search>
</div>

@if (
    isMobile &&
    !showHelpExpanded &&
    error &&
    (error.orderNumberItemsChecked === undefined || error.orderNumberItemsChecked === true)
) {
    <div class="error-text-mobile">
        {{ error.content | translate }}
    </div>
}

<sew-button class="search-multiple" hierarchy="tertiary" size="xs" icon="list">
    <button (click)="openMultipleInputModal()">
        {{ 'SEARCH.MULTIPLE.TITLE' | translate }}
    </button>
</sew-button>

@if (isMobile && showHelpExpanded) {
    <div #searchHelpWrapper class="search-help-wrapper mobile">
        <osc-search-help
            [latestSearchTerms]="latestSearchTerms$ | async"
            [criteriaExplanation]="criteriaExplanation$ | async"
            [showSearchCriteria]="true"
            (closeClicked)="showHelpExpanded = $event"
            (latestSearchTermClicked)="searchValue = $event; onSearch()"
            [isMobile]="isMobile"
        ></osc-search-help>
    </div>
}
